import type { TOC } from '@ember/component/template-only';
import HotelAndMarketRatesExportModalRatesExportModal from 'lumen/components/hotel-and-market/rates/export-modal/rates-export-modal';
import type MarketMarketratesExportController from 'lumen/controllers/market/marketrates/export';

interface MarketMarketratesExportSignature {
  Args: {
    controller: MarketMarketratesExportController;
    model: unknown;
  };
}

<template>
  <HotelAndMarketRatesExportModalRatesExportModal
    @cancel={{@controller.closeModal}}
    @isMarket={{true}}
    @params={{@controller.tabsParams}}
  />
</template> satisfies TOC<MarketMarketratesExportSignature>;
